export const BASE_TAG = 'inline-flex items-center h-24 font-caption';

export const LINK_TAG_TYPES = {
  light: `${BASE_TAG} text-base-lighter border border-solid border-gray-main`,
  dark: `${BASE_TAG} text-base-lighter bg-base-lighter-24`,
  'primary-light': `${BASE_TAG} text-white bg-primary-lighter`,
  'primary-dark': `${BASE_TAG} text-white bg-primary-lighter`,
};

export const TEXT_TAG_DEFAULT = `${BASE_TAG} px-8 text-white bg-purple-lighter`;
export const TEXT_TAG_RED = `${BASE_TAG} px-8 text-white bg-red-main`;
export const TEXT_TAG_YELLOW = `${BASE_TAG} px-8 text-base-main bg-yellow-main`;
export const TEXT_TAG_GREEN = `${BASE_TAG} px-8 text-base-main bg-green-main`;

export const GREEN_STATE_TAG = `${BASE_TAG} px-8 text-base-main bg-green-main`;
export const YELLOW_STATE_TAG = `${BASE_TAG} px-8 text-base-main bg-yellow-main`;
export const ORANGE_STATE_TAG = `${BASE_TAG} px-8 text-white bg-orange-main`;
export const RED_STATE_TAG = `${BASE_TAG} px-8 text-white bg-red-main`;

export const TAGS = {
  link: LINK_TAG_TYPES,
  text: {
    default: TEXT_TAG_DEFAULT,
    red: TEXT_TAG_RED,
    yellow: TEXT_TAG_YELLOW,
    green: TEXT_TAG_GREEN,
  },
  state: {
    green: GREEN_STATE_TAG,
    yellow: YELLOW_STATE_TAG,
    orange: ORANGE_STATE_TAG,
    red: RED_STATE_TAG,
  },
};
